import React, { useContext } from 'react';
import { AuthContext } from '../../context/AuthContext';
import { isLakehouseContext } from '../../utils/restaurantContext';

// Using public folder images (public/images/*) so we just reference them by absolute path.
// If you later move images into src/assets/images, revert to import statements for bundling.
const IMAGES = [
  { id: 1, src: '/images/explore-1.png', alt: 'Casa Gatchalian Entrance Sign' },
  { id: 2, src: '/images/explore-2.png', alt: 'Casa Gatchalian Pool Area' },
  { id: 3, src: '/images/explore-3.jpg', alt: 'Casa Gatchalian Dining Interior' }
];

const RESTAURANT_TWO_IMAGES = [
  { id: 1, src: '/images/casagatchalianlakehouse - explore 1.jpg', alt: 'Cocktail drinks and table setup at Casa Gatchalian Lakehouse' },
  { id: 2, src: '/images/casagatchalianlakehouse - explore 2.jpg', alt: 'Balcony seating with lake and mountain view at Casa Gatchalian Lakehouse' },
  { id: 3, src: '/images/casagatchalianlakehouse - explore 3.jpg', alt: 'Dining area interior at Casa Gatchalian Lakehouse' }
];

const CASA_GATCHALIAN_DESCRIPTION =
  "Casa Gatchalian is a unique restaurant built from old house materials, giving it a cozy, nostalgic feel with a relaxing sea view. Starting with classic Batangas pancit and lomi, the menu expanded to a wide range of local and international dishes. Word spread through social media, making Casa Gatchalian a popular spot for gatherings and celebrations. Despite financial challenges and the pandemic, the restaurant remains strong and continues to welcome guests. when you dine here at casa gatchalian, you'll feel relaxed and at home. Casa gatchalian, ang Casalo mo sa hain ng buhay.";

const LAKEHOUSE_DESCRIPTION =
  'Nestled along the serene lakefront, Casa Gatchalian Lakehouse is a cozy destination built from repurposed materials. What began with classic Batangas pancit and lomi has grown into a menu of local and international favorites, making it a popular place for gatherings and celebrations. From the open-air balcony and grand dining hall, guests enjoy panoramic views of Taal Volcano across the water, creating a calm and homey dining experience.';

const ExploreSection = () => {
  const { user } = useContext(AuthContext);
  const isRestaurantTwoUser = isLakehouseContext(user);
  const exploreImages = isRestaurantTwoUser ? RESTAURANT_TWO_IMAGES : IMAGES;

  return (
    <section id="explore" className="bg-[#A48F60] py-12 sm:py-16 lg:py-20 scroll-mt-20 sm:scroll-mt-24">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-12 grid lg:grid-cols-[minmax(0,520px)_minmax(0,560px)] gap-8 sm:gap-10 lg:gap-14 items-start">
        {/* Text Column */}
        <div className="text-center lg:text-left">
          <h2 className="font-bebas text-3xl sm:text-4xl md:text-5xl lg:text-6xl leading-tight text-white mb-6 sm:mb-8 tracking-wide">
            {isRestaurantTwoUser ? 'CASA GATCHALIAN LAKEHOUSE' : 'CASA GATCHALIAN'}
          </h2>
          <p className="text-white/90 leading-relaxed font-montserrat text-sm sm:text-[15px] md:text-base max-w-md mx-auto lg:mx-0">
            {isRestaurantTwoUser ? (
              <>
                {LAKEHOUSE_DESCRIPTION}
                <br />
                <strong>Casa Gatchalian, ang Casalo mo sa hain ng buhay.</strong>
              </>
            ) : (
              CASA_GATCHALIAN_DESCRIPTION
            )}
          </p>
        </div>

        {/* Collage Column */}
        <div className="w-full max-w-xl mx-auto lg:mx-0">
          <div className="grid grid-cols-[1fr_1fr] gap-3 sm:gap-4 h-full">
            {/* Left column (two stacked images) */}
            <div className="flex flex-col gap-3 sm:gap-4">
              <div className="relative h-40 sm:h-48 md:h-56 lg:h-60 overflow-hidden rounded shadow-md">
                <img
                  src={exploreImages[0].src}
                  alt={exploreImages[0].alt}
                  className="absolute inset-0 w-full h-full object-cover hover:scale-[1.04] transition-transform duration-500"
                  loading="lazy"
                />
              </div>
              <div className="relative h-40 sm:h-48 md:h-56 lg:h-60 overflow-hidden rounded shadow-md">
                <img
                  src={exploreImages[1].src}
                  alt={exploreImages[1].alt}
                  className="absolute inset-0 w-full h-full object-cover hover:scale-[1.04] transition-transform duration-500"
                  loading="lazy"
                />
              </div>
            </div>
            {/* Right tall image */}
            <div className="relative row-span-2 h-full min-h-[21rem] sm:min-h-[26rem] md:min-h-[28rem] lg:min-h-[30rem] overflow-hidden rounded shadow-md">
              <img
                src={exploreImages[2].src}
                alt={exploreImages[2].alt}
                className="absolute inset-0 w-full h-full object-cover hover:scale-[1.04] transition-transform duration-500"
                loading="lazy"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ExploreSection;
